import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text} from '@chakra-ui/react'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {EditorialVideo} from '../../video'
import SanitizedHtml from '../../../html-sanitizer'

export const StoriesSwiperSlide = ({title, bodyCopy, isVideo, video, image, styles}) => {
    const damImage = useDamImage(image)

    return (
        <Flex data-testid="stories-swiper-slide" {...styles.slide}>
            {isVideo ? (
                <Box w={'100%'} h={'100%'}>
                    <EditorialVideo data={video} style={{objectFit: 'cover'}} />
                </Box>
            ) : (
                <AspectRatio ratio={damImage.ratio} w={'100%'}>
                    <Img
                        src={damImage.url}
                        alt={image?.alt || ''}
                        {...styles.slidemedia}
                        className={'slideimage'}
                    />
                </AspectRatio>
            )}
            <Flex {...styles.slidetextblock}>
                {title && (
                    <Box {...styles.slidetitle}>
                        <Text {...styles.slidetitletext}>{title}</Text>
                    </Box>
                )}
                {bodyCopy && (
                    <Box {...styles.slidebodycopy}>
                        <SanitizedHtml as={Text} html={bodyCopy} {...styles.slidebodycopyhtml} />
                    </Box>
                )}
            </Flex>
            <Box {...styles.slidemask}></Box>
        </Flex>
    )
}

StoriesSwiperSlide.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    isVideo: PropTypes.bool,
    video: PropTypes.shape(),
    image: PropTypes.shape(),
    styles: PropTypes.shape(),
}
